module.exports = __webpack_public_path__ + "img/2_1_m.3d961120.jpg";